import React from 'react'
import moment from 'moment'
import EditProductionMethod from '../Actions/EditProductionMethod'

function ProductionMethodsRow(props) {
    const { item, reset } = { ...props }
    const { name, code, partner, updated } = { ...item }
    const { name: partner_name = '-' } = Object.assign({}, partner)

    return (
        <tr className='ProductionMethodsRow'>
            <td> {name || '-'}</td>
            <td>{code || '-'}</td>
            <td>{partner_name}</td>
            <td>{updated ? moment(updated).format("DD/MM/YYYY HH:mm:ss") : '-'}</td>
            <td>
                <EditProductionMethod
                    item={item}
                    reset={reset}
                />
            </td>
        </tr>
    )
}

export default ProductionMethodsRow